
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/genEd/[[...slug]]",
      function () {
        return require("private-next-pages/genEd/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/genEd/[[...slug]]"])
      });
    }
  